// Example of SVG converted to js array, so it can be used with CIcon.
// the first argument is two last values of svg viewBox,
// the second argument is the SVG content stripped of SVG tags
export const logo = ['556 134',`
  <g transform="translate(0.000000,85.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
<path d="M498 725 l-3 -74 33 31 c21 21 32 41 31 57 -1 15 2 34 6 44 6 14 2
17 -28 17 l-35 0 -4 -75z"/>
<path d="M650 681 c0 -136 -8 -123 90 -135 58 -7 140 -31 165 -50 18 -13 20
-28 23 -178 3 -151 13 -218 33 -218 10 0 93 133 114 183 20 48 14 67 -55 196
-94 176 -156 275 -184 296 -21 15 -46 21 -107 24 l-79 3 0 -121z"/>
<path d="M1400 735 c0 -11 -12 -15 -45 -15 -38 0 -45 -3 -45 -20 0 -19 7 -20
110 -20 103 0 110 1 110 20 0 17 -7 20 -45 20 -33 0 -45 4 -45 15 0 8 -9 15
-20 15 -11 0 -20 -7 -20 -15z"/>
<path d="M2090 735 c0 -11 -11 -15 -40 -15 -29 0 -40 -4 -40 -15 0 -12 18 -15
105 -15 87 0 105 3 105 15 0 11 -11 15 -40 15 -29 0 -40 4 -40 15 0 9 -9 15
-25 15 -16 0 -25 -6 -25 -15z"/>
<path d="M3574 726 c-21 -18 -28 -32 -28 -61 0 -32 6 -44 37 -70 20 -18 37
-35 37 -39 0 -3 -31 -6 -70 -6 -63 0 -70 -2 -70 -20 0 -19 7 -20 160 -20 153
0 160 1 160 20 0 18 -7 20 -70 20 -38 0 -70 4 -70 8 0 5 14 18 31 31 40 30 53
66 38 103 -25 61 -104 78 -155 34z m94 -22 c37 -26 20 -94 -24 -94 -53 0 -75
64 -32 94 12 9 25 16 28 16 3 0 16 -7 28 -16z"/>
<path d="M1570 630 c0 -103 1 -110 20 -110 17 0 20 7 20 45 0 41 2 45 25 45
18 0 25 5 25 20 0 15 -7 20 -25 20 -23 0 -25 4 -25 45 0 38 -3 45 -20 45 -19
0 -20 -7 -20 -110z"/>
<path d="M1690 720 c0 -19 7 -20 115 -20 l115 0 0 -35 c0 -28 4 -35 20 -35 18
0 20 7 20 55 l0 55 -135 0 c-128 0 -135 -1 -135 -20z"/>
<path d="M2280 710 c0 -27 -3 -30 -30 -30 -39 0 -41 -27 -3 -32 17 -2 29 -10
31 -20 3 -14 -3 -18 -27 -18 -21 0 -31 -5 -31 -15 0 -9 10 -15 26 -15 17 0 28
-6 31 -20 3 -11 14 -20 24 -20 17 0 19 9 19 100 0 93 -1 100 -20 100 -16 0
-20 -7 -20 -30z"/>
<path d="M3030 565 l0 -175 25 0 c25 0 25 1 25 85 0 84 0 85 25 85 18 0 25 5
25 20 0 15 -7 20 -25 20 -24 0 -25 2 -25 70 0 68 -1 70 -25 70 l-25 0 0 -175z"/>
<path d="M3870 675 c-31 -39 -50 -71 -46 -80 9 -25 23 -17 61 35 20 28 38 50
40 50 1 0 20 -22 41 -49 31 -42 40 -48 56 -40 17 9 15 15 -28 69 -70 90 -65
89 -124 15z"/>
<path d="M4090 660 c0 -73 2 -80 20 -80 18 0 20 7 20 80 0 73 -2 80 -20 80
-18 0 -20 -7 -20 -80z"/>
<path d="M2531 641 c-39 -50 -71 -95 -71 -100 0 -5 7 -11 15 -15 10 -4 34 18
74 69 l59 74 58 -74 c31 -41 60 -75 63 -75 4 0 12 5 18 11 9 9 -5 34 -58 103
-39 50 -74 92 -79 94 -4 2 -40 -38 -79 -87z"/>
<path d="M2790 580 l0 -140 90 0 90 0 0 140 0 140 -90 0 -90 0 0 -140z m138
-2 l-3 -103 -45 0 -45 0 -3 103 -3 102 51 0 51 0 -3 -102z"/>
<path d="M3160 615 l0 -105 135 0 c128 0 135 1 135 20 0 19 -7 20 -115 20
l-115 0 0 25 0 25 115 0 c108 0 115 1 115 20 0 19 -7 20 -115 20 l-115 0 0 25
0 25 115 0 c96 0 115 3 115 15 0 13 -22 15 -135 15 l-135 0 0 -105z"/>
<path d="M1365 645 c-51 -50 -16 -125 58 -125 48 0 77 28 77 74 0 68 -86 101
-135 51z m93 -47 c6 -47 -59 -62 -73 -17 -9 27 13 51 44 47 20 -2 27 -9 29
-30z"/>
<path d="M2051 644 c-12 -15 -21 -34 -21 -44 0 -10 9 -29 21 -44 24 -31 81
-36 117 -10 31 21 31 87 0 108 -36 26 -93 21 -117 -10z m93 -26 c8 -13 8 -23
0 -35 -15 -24 -44 -23 -61 3 -12 19 -12 24 3 38 20 20 43 18 58 -6z"/>
<path d="M1660 580 c0 -18 7 -20 75 -20 73 0 75 -1 75 -25 0 -24 -3 -25 -60
-25 -53 0 -60 -2 -60 -20 0 -19 7 -20 115 -20 l115 0 0 -40 c0 -33 3 -40 20
-40 18 0 20 7 20 60 l0 60 -55 0 c-52 0 -55 1 -55 25 0 24 2 25 70 25 63 0 70
2 70 20 0 19 -7 20 -165 20 -158 0 -165 -1 -165 -20z"/>
<path d="M422 535 c-6 -14 -10 -25 -7 -25 13 0 64 38 58 43 -14 15 -40 6 -51
-18z"/>
<path d="M3850 540 c0 -19 7 -20 120 -20 100 0 120 -2 120 -15 0 -12 -20 -15
-120 -15 l-120 0 0 -50 0 -50 140 0 c133 0 140 1 140 20 0 19 -7 20 -120 20
-100 0 -120 3 -120 15 0 13 20 15 120 15 l120 0 0 50 0 50 -140 0 c-133 0
-140 -1 -140 -20z"/>
<path d="M2190 533 c-91 -34 -73 -153 24 -153 44 0 86 36 86 74 0 48 -66 96
-110 79z m52 -50 c24 -22 23 -39 -6 -58 -29 -19 -54 -10 -62 21 -12 46 32 70
68 37z"/>
<path d="M1330 445 l0 -55 145 0 c138 0 145 1 145 20 0 18 -8 20 -122 22
l-123 3 -3 33 c-2 24 -8 32 -23 32 -16 0 -19 -7 -19 -55z"/>
<path d="M3500 440 l0 -50 140 0 c133 0 140 1 140 20 0 19 -7 20 -115 20
l-115 0 0 30 c0 25 -4 30 -25 30 -23 0 -25 -3 -25 -50z"/>
<path d="M2440 430 c0 -19 7 -20 165 -20 158 0 165 1 165 20 0 19 -7 20 -165
20 -158 0 -165 -1 -165 -20z"/>
<path d="M3130 430 c0 -19 7 -20 165 -20 158 0 165 1 165 20 0 19 -7 20 -165
20 -158 0 -165 -1 -165 -20z"/>
<path d="M3513 260 c0 -52 2 -75 4 -50 5 53 18 72 47 68 17 -2 22 -12 27 -58
l6 -55 -1 54 c-1 62 -21 85 -55 64 -18 -12 -20 -9 -24 30 -2 23 -4 -1 -4 -53z"/>
<path d="M1353 255 c0 -50 2 -70 4 -46 l4 44 47 -44 46 -44 -36 46 -36 45 36
45 36 44 -47 -44 -46 -44 -4 44 c-2 24 -4 4 -4 -46z"/>
<path d="M2182 328 c-23 -23 -14 -55 23 -77 44 -26 54 -49 30 -67 -10 -8 -14
-14 -8 -14 18 0 35 28 28 49 -3 11 -22 29 -41 40 -48 28 -45 63 6 72 35 6 35
6 5 8 -17 0 -36 -4 -43 -11z"/>
<path d="M2885 315 c-14 -13 -25 -32 -25 -42 1 -11 6 -5 15 14 14 34 48 50 85
40 11 -3 20 -1 20 4 0 5 -16 9 -35 9 -25 0 -44 -8 -60 -25z"/>
<path d="M2721 308 c0 -9 -7 -19 -13 -21 -10 -4 -10 -6 0 -6 8 -1 12 -18 12
-50 0 -28 3 -52 8 -54 4 -3 5 19 4 48 -3 45 -1 54 15 58 15 4 15 5 1 6 -9 0
-19 9 -21 19 -4 15 -5 15 -6 0z"/>
<path d="M1498 279 c-10 -5 -18 -18 -18 -27 0 -13 3 -12 16 6 17 24 53 29 72
10 17 -17 15 -58 -5 -80 -9 -10 -11 -18 -5 -18 6 0 16 9 22 19 33 63 -23 125
-82 90z"/>
<path d="M1630 230 c0 -35 2 -61 4 -59 8 8 10 108 3 116 -4 3 -7 -22 -7 -57z"/>
<path d="M1755 283 c11 -3 26 -12 33 -21 6 -9 12 -11 12 -6 0 17 -23 34 -44
33 -21 -1 -21 -1 -1 -6z"/>
<path d="M1880 281 c30 -8 39 -37 13 -44 -16 -4 -16 -5 -1 -6 11 -1 18 -12 21
-33 2 -21 4 -12 5 23 2 59 -6 70 -46 68 -10 -1 -6 -4 8 -8z"/>
<path d="M2020 281 c22 -6 26 -14 31 -61 l6 -55 1 51 c2 54 -10 75 -42 73 -18
-1 -17 -2 4 -8z"/>
<path d="M2303 230 c0 -36 2 -50 4 -32 2 17 2 47 0 65 -2 17 -4 3 -4 -33z"/>
<path d="M2347 283 c24 -4 30 -20 36 -83 2 -26 4 -21 7 22 3 31 2 54 -2 52 -4
-2 -9 0 -13 6 -3 5 -16 9 -28 9 l-22 -2 22 -4z"/>
<path d="M2420 284 c8 -4 21 -14 28 -23 13 -14 13 -14 10 4 -2 13 -12 21 -28
22 -14 1 -18 0 -10 -3z"/>
<path d="M2550 281 c30 -8 39 -37 13 -44 -16 -4 -16 -5 -1 -6 11 -1 18 -12 21
-33 3 -24 4 -19 5 18 2 54 -10 75 -42 73 -18 -1 -17 -2 4 -8z"/>
<path d="M2632 230 c0 -36 3 -51 5 -35 7 60 14 76 36 85 16 6 17 9 5 9 -9 1
-20 -4 -24 -10 -4 -8 -9 -7 -15 2 -5 9 -8 -11 -7 -51z"/>
<path d="M3032 230 c1 -56 2 -58 5 -18 3 35 10 52 26 63 12 8 16 15 10 15 -7
0 -15 -5 -19 -11 -4 -8 -9 -7 -15 2 -5 9 -8 -11 -7 -51z"/>
<path d="M3126 274 c-29 -29 -15 -105 19 -104 5 0 2 5 -7 11 -11 6 -18 22 -18
42 0 37 15 57 42 57 18 0 42 -33 31 -44 -3 -3 -1 -6 6 -6 8 0 10 8 5 23 -12
39 -50 50 -78 21z"/>
<path d="M3285 283 c11 -3 26 -12 33 -21 6 -9 12 -11 12 -6 0 17 -23 34 -44
33 -21 -1 -21 -1 -1 -6z"/>
<path d="M3373 230 c0 -50 1 -55 4 -20 3 24 9 50 15 57 15 18 45 16 58 -4 10
-16 10 -16 8 2 -4 23 -42 32 -63 15 -10 -8 -14 -8 -18 2 -3 7 -5 -16 -4 -52z"/>
<path d="M3658 279 c-10 -5 -18 -18 -18 -27 0 -13 3 -12 16 6 17 24 53 29 72
10 17 -17 15 -58 -5 -80 -9 -10 -11 -18 -5 -18 6 0 16 9 22 19 33 63 -23 125
-82 90z"/>
<path d="M3870 240 c0 -36 -5 -52 -17 -59 -16 -9 -15 -10 5 -8 20 1 22 6 22
59 0 32 -2 58 -5 58 -3 0 -5 -22 -5 -50z"/>
<path d="M3927 283 c-10 -9 -9 -41 2 -47 4 -3 6 5 4 19 -4 20 0 24 23 28 28 4
28 4 3 6 -14 0 -29 -2 -32 -6z"/>
<path d="M4036 274 c-29 -29 -15 -105 19 -104 5 0 2 5 -7 11 -11 6 -18 22 -18
42 0 37 15 57 42 57 18 0 42 -33 31 -44 -3 -3 -1 -6 6 -6 8 0 10 8 5 23 -12
39 -50 50 -78 21z"/>
<path d="M1709 256 c-13 -27 -1 -77 20 -84 9 -3 8 3 -3 20 -15 22 -15 55 -1
78 3 6 4 10 0 10 -3 0 -10 -11 -16 -24z"/>
<path d="M1975 269 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"/>
<path d="M3239 256 c-13 -27 -1 -77 20 -84 9 -3 8 3 -3 20 -15 22 -15 55 -1
78 3 6 4 10 0 10 -3 0 -10 -11 -16 -24z"/>
<path d="M2958 243 c17 -3 22 -11 22 -33 0 -17 -6 -30 -15 -33 -11 -4 -10 -4
2 -3 13 1 19 11 21 39 3 35 2 37 -25 36 -23 -2 -24 -2 -5 -6z"/>
<path d="M2861 230 c-1 -23 28 -60 47 -60 13 0 11 4 -6 16 -13 9 -27 26 -32
38 -6 13 -9 15 -9 6z"/>
<path d="M1840 215 c-14 -16 -7 -45 11 -45 8 0 8 4 -1 15 -10 12 -10 18 0 30
7 8 10 15 7 15 -2 0 -10 -7 -17 -15z"/>
<path d="M2504 215 c-8 -20 2 -45 18 -45 9 0 8 3 -2 10 -12 8 -13 13 -2 30 7
12 8 20 2 20 -6 0 -13 -7 -16 -15z"/>
<path d="M3965 216 c16 -12 17 -16 6 -30 -7 -9 -9 -16 -3 -16 5 0 13 7 16 16
7 18 -10 44 -27 44 -6 0 -2 -6 8 -14z"/>
<path d="M1481 209 c-1 -19 26 -45 36 -35 3 3 1 6 -6 6 -6 0 -16 10 -21 23 -6
15 -9 17 -9 6z"/>
<path d="M3641 209 c-1 -19 26 -45 36 -35 3 3 1 6 -6 6 -6 0 -16 10 -21 23 -6
15 -9 17 -9 6z"/>
<path d="M3790 191 c0 -10 19 -25 25 -20 1 2 -3 10 -11 17 -8 7 -14 8 -14 3z"/>
</g>
`]
